<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import inAppBrowserMixin from '@/mixins/inAppBrowserMixin';

export default {
  name: 'HarmonyLayout',
  
  mixins: [inAppBrowserMixin],
  
  mounted() {
    // Solo detectar y redirigir en rutas públicas de Harmony (no en editor)
    // Todo es automático: si funciona redirige, si no, continúa normal
    if (!this.$route.path.includes('/editor')) {
      this.initInAppBrowserDetection();
    }
  }
};
</script>

<style scoped>

</style>
